module.exports = __webpack_public_path__ + "static/img/cocina_21.9b82246c.png";